<template>
  <span>
    <!-- <h4>{{dc.nombre}}</h4> -->
    <!-- <h5>{{dc}}</h5> -->
    <!-- <h5>{{datosRegistro[dc.nombre]}}</h5> -->
    <v-switch
      v-if="dc.control == 'switch'"
      :ref="dc.nombre"
      :label="labelCampo"
      dense
      inset
      :color="colorCampo"
      class="mt-n1"
      v-model="datosRegistro[dc.nombre]"
      v-bind="$attrs"
    ></v-switch>

    <template v-else-if="itemsSelect">
      <v-autocomplete
        v-if="dc.control == 'autocomplete'"
        :ref="dc.nombre"
        :label="labelCampo"
        :color="colorCampo"
        :rules="dc.requerido ? [validacionCampo] : []"
        :items="itemsSelect"
        dense
        v-model="datosRegistro[dc.nombre]"
        v-bind="$attrs"
      ></v-autocomplete>
      <v-select
        v-else
        :ref="dc.nombre"
        :label="labelCampo"
        :color="colorCampo"
        :rules="dc.requerido ? [validacionCampo] : []"
        :items="itemsSelect"
        :prepend-inner-icon="prependInnerIconCampo"
        dense
        v-model="datosRegistro[dc.nombre]"
        v-bind="$attrs"
        @change="$emit('change', $event, dc, datosRegistro)"
      ></v-select>
    </template>
<!--        @change="$emit('change', $event, datosRegistro, definicionCampos)"-->

    <v-textarea
      v-else-if="dc.control == 'textarea'"
      :ref="dc.nombre"
      :label="labelCampo"
      :color="colorCampo"
      :rules="dc.requerido ? [validacionCampo] : []"
      :maxlength="dc.longitud"
      dense
      rows="2"
      auto-grow
      v-model="datosRegistro[dc.nombre]"
      v-bind="$attrs"
    ></v-textarea>

    <SelectorFechaHora
      v-else-if="dc.control == 'date-picker'"
      :ref="dc.nombre"
      :titulo-fecha="labelCampo"
      titulo-hora=""
      formato-fecha="cccc, dd/MM/yyyy"
      formato-hora="HH:mm"
      literal-null="(Indefinido)"
      formato-modelo="sql"
      boton-borrar
      v-model="datosRegistro[dc.nombre]"
      v-bind="$attrs"
    />

    <v-text-field
      v-else
      :ref="dc.nombre"
      :label="labelCampo"
      :color="colorCampo"
      :rules="dc.requerido ? [validacionCampo] : []"
      :maxlength="dc.longitud"
      :type="dc.contrasena || dc.ocultar_valor ? 'password' : 'text'"
      :prepend-inner-icon="prependInnerIconCampo"
      :prefix="(dc.prefijo_valor ? dc.prefijo_valor : '')"
      :suffix="(dc.sufijo_valor ? dc.sufijo_valor : '')"
      dense
      v-model="datosRegistro[dc.nombre]"
      v-bind="$attrs"
      v-inputfilter="$attrs.inputfilter"
    ></v-text-field>
  </span>
</template>

<script>
import SelectorFechaHora from '../components/SelectorFechaHora.vue'

export default {
  components: { SelectorFechaHora },
  props: {
    nombreCampo: {
      type: String,
      required: true
    },
    definicionCampos: { // definicion de los campos
      type: Object,
      required: true
    },
    datosRegistro: { // datos del registro
      type: Object,
      required: true
    }
  },
  data: () => ({
    itemsSelect: null
  }),
  computed: {
    dc () {
      return this.definicionCampos [this.nombreCampo];
    },
    labelCampo () {
      if (this.$attrs ['label'])
        return this.$attrs ['label'];
      else
        return this.dc.titulo;
    },
    colorCampo () {
      if (this.$attrs.readonly)
        return "silver";
      else if (this.$attrs ['color'])
        return this.$attrs ['color'];
      else
        return this.dc.color;
    },
    prependInnerIconCampo () {
      if (this.$attrs ['prepend-inner-icon'])
        return this.$attrs ['prepend-inner-icon'];
      else
        return this.dc.icono;
    }
  },
  methods: {
    validacionCampo (valor) {
      return (valor != undefined) && (valor != "");
    },
    actualizarItemsSelect(){
      if (this.dc.dominio_valores) {
        let valorEncontrado = false;
        this.itemsSelect = [];
        Object.entries (this.dc.dominio_valores).forEach(
          ([value, text]) => {
            this.itemsSelect.push({ value: JSON.parse (value), text: text });
            if (this.datosRegistro [this.nombreCampo] == JSON.parse (value))
              valorEncontrado = true;
          }
        );
        if (!valorEncontrado)
          this.datosRegistro [this.nombreCampo] = null;
      }
    },
    focus () {
      this.$children[0].focus();
    }
  },
  beforeMount (){
    this.actualizarItemsSelect();
    this.$vnode.context.$refs[this.nombreCampo] = [];
    this.$vnode.context.$refs[this.nombreCampo][0] = this;
  }
}
</script>

<style>
</style>